import { createLazyComponent, LazyModule, LazyImport } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "FavoritePdlEditor" */ './lazyIndex');
});
export var lazyCreateNewPdlFavoriteClickedAction = new LazyImport(lazyModule, function (m) { return m.createNewPdlFavoriteClickedAction; });
export var PrivateDistributionlistModalEditor = createLazyComponent(lazyModule, function (m) { return m.PrivateDistributionlistModalEditor; });
//# sourceMappingURL=index.js.map